module.exports = "query GetPossibleSponsors {\n  account {\n    possibleSponsors {\n      ...SponsorFragment\n    }\n  }\n}\n"